// this is an autogenerated file from App/Account/Content/Settings/Content/ConnectDevelopers/Keys/mutation.graphql
import { gql } from 'Data/Api'

export default gql`
mutation app__App_Account_Content_Settings_Content_ConnectDevelopers_Keys($id: uuid!, $status: apps_key_status_enum!) {
  update_apps_keys_by_pk(pk_columns: { id: $id }, _set: { status: $status }) {
    id
  }
}

`